import { Injectable, isDevMode } from '@angular/core';

export enum LogLevel {
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
}

@Injectable({
  providedIn: 'any',
})
export class Logger {
  private enabled: boolean;

  constructor() {
    this.enabled = isDevMode();
  }

  private formatMessage(level: LogLevel, message: any): string {
    const time = new Date().toISOString();
    return `[${time}] [${level}] ${message}`;
  }

  debug(message: any, ...optionalParams: any[]) {
    if (this.enabled) console.debug(this.formatMessage(LogLevel.DEBUG, message), ...optionalParams);
  }

  info(message: any, ...optionalParams: any[]) {
    if (this.enabled) console.info(this.formatMessage(LogLevel.INFO, message), ...optionalParams);
  }

  warn(message: any, ...optionalParams: any[]) {
    if (this.enabled) console.warn(this.formatMessage(LogLevel.WARN, message), ...optionalParams);
  }

  error(message: any, ...optionalParams: any[]) {
    if (this.enabled) console.error(this.formatMessage(LogLevel.ERROR, message), ...optionalParams);
  }
}
